import { CircularProgress, Stack } from '@rossum/ui/material';
import { Redirect, Route, RouteChildrenProps, Switch } from 'react-router';
import AutomationDetail from '../../../containers/Queue/containers/AutomationDetail';
import QueueAccess from '../../../containers/Queue/containers/QueueAccess/QueueAccess';
import { QueueEmails } from '../../../containers/Queue/containers/QueueEmails';
import QueueSchema from '../../../containers/Queue/containers/QueueSchema';
import { QueueBasicSettings } from '../../../containers/Queue/containers/QueueSettings';
import { HelmetComponent } from '../../../routes/HelmetComponent';
import { useQueueWithWorkspace } from '../../queues/hooks/useQueueWithWorkspace';
import { FieldsRoute } from './FieldsRoute';
import { RulesRoute } from './RulesRoute';

export const QueueSettingsRoute = (
  props: RouteChildrenProps<{ queueId: string }>
) => {
  const { match, location } = props;

  const queueId = Number(match?.params.queueId);
  const { queue, queueIsLoading, workspace } = useQueueWithWorkspace({
    queueId,
  });

  if (!match) {
    return null;
  }

  if (!queue) {
    if (queueIsLoading) {
      return (
        <Stack
          sx={{
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Stack>
      );
    }

    return <Redirect to="/documents" />;
  }

  return (
    <>
      <HelmetComponent
        dynamicName={queue.name}
        translationKey="features.routes.pageTitles.queueSettings"
      />
      <Switch>
        <Route path={`${match.path}/schema`}>
          <QueueSchema
            {...props}
            match={match}
            queue={queue}
            workspaceName={workspace?.name}
          />
        </Route>
        <Route>
          <Switch location={location}>
            <Route path={`${match.path}/basic`}>
              <QueueBasicSettings {...props} match={match} />
            </Route>
            <Route path={`${match.path}/fields`}>
              <FieldsRoute {...props} queue={queue} />
            </Route>
            <Route path={`${match.path}/rules`}>
              <RulesRoute currentQueue={queue} {...props} />
            </Route>
            <Route path={`${match.path}/emails`}>
              <QueueEmails {...props} match={match} />
            </Route>
            <Route path={`${match.path}/automation`}>
              <AutomationDetail selectedQueue={queue} parentPath={match.url} />
            </Route>
            <Route path={`${match.path}/access`}>
              <QueueAccess selectedQueue={queue} {...props} />
            </Route>
            <Route
              path={`${match.path}/`}
              render={() => (
                <Redirect
                  to={{
                    pathname: `${match.url}/basic`,
                    state: location.state,
                  }}
                />
              )}
            />
          </Switch>
        </Route>
      </Switch>
    </>
  );
};
